<template>
  <div class="multi-wrap">
    <div class="banner">
      <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M12 8v4M12 16h.01"/></svg>
      <div><b>Режим в разработке.</b> Ссылки собираются и копируются прямо в браузере. Создание записей в реестре и сокращение для пачки подключим отдельно.</div>
    </div>

    <section class="card multi">
      <div class="multi-head">
        <div>
          <h2>Пачка ссылок</h2>
          <p>Один адрес — много площадок, или наоборот. Метки кампании общие, у каждой строки — свой адрес и событие.</p>
        </div>
      </div>

      <div class="shared">
        <div class="grid3">
          <div>
            <span class="lbl">Тип трафика</span>
            <SelectVue
              v-model="lead"
              :options="leads"
              filter
              appendTo="body"
              placeholder="Выберите"
              class="utm-select"
            />
          </div>
          <div>
            <span class="lbl">Кампания</span>
            <SelectVue
              v-model="campaign"
              :options="campaigns"
              optionLabel="name"
              optionValue="value"
              editable
              filter
              appendTo="body"
              placeholder="Кампания"
              class="utm-select"
            />
          </div>
          <div>
            <span class="lbl">Дата запуска</span>
            <DatePicker v-model="termDate" dateFormat="dd.mm.yy" showIcon appendTo="body" class="term-picker" placeholder="дд.мм.гг" />
          </div>
        </div>
      </div>

      <div class="table-wrap">
        <table class="table">
          <thead>
            <tr>
              <th class="num">#</th>
              <th>Адрес страницы</th>
              <th>Источник</th>
              <th>Площадка</th>
              <th>Событие</th>
              <th>Результат</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" :key="row.id" :class="{ bad: issueOf(row) }">
              <td class="num">{{ index + 1 }}</td>
              <td class="url-cell">
                <input class="input" :value="row.url" placeholder="get-nechto.ru/…" spellcheck="false" @input="onUrl(row, $event)">
                <div v-if="issueOf(row)" class="err">{{ issueOf(row) }}</div>
              </td>
              <td>
                <SelectVue
                  :modelValue="row.origin"
                  :options="originsFor(lead)"
                  filter
                  appendTo="body"
                  placeholder="Источник"
                  class="utm-select"
                  @update:modelValue="onOrigin(row, $event)"
                />
              </td>
              <td>
                <SelectVue
                  :modelValue="row.platform"
                  :options="platformsFor(row)"
                  filter
                  appendTo="body"
                  placeholder="Площадка"
                  class="utm-select"
                  @update:modelValue="onPlatform(row, $event)"
                />
              </td>
              <td>
                <SelectVue
                  :modelValue="row.eventId"
                  :options="eventsFor(row)"
                  optionLabel="event"
                  optionValue="id"
                  filter
                  appendTo="body"
                  placeholder="Событие"
                  class="utm-select"
                  @update:modelValue="row.eventId = $event"
                />
              </td>
              <td>
                <span v-if="resultOf(row)" class="res" :title="resultOf(row)">
                  {{ formatUrlForDisplay(resultOf(row), 42) }}
                  <button type="button" class="copy" title="Скопировать" @click="copyOne(resultOf(row))">⧉</button>
                </span>
                <span v-else class="res empty">—</span>
              </td>
              <td class="row-actions">
                <button type="button" title="Удалить" @click="removeRow(row.id)">✕</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="multi-foot">
        <button type="button" class="btn sm" @click="addRows(1)">＋ Строка</button>
        <button type="button" class="btn sm" @click="addRows(5)">＋ 5 строк</button>
        <div class="grow"></div>
        <span class="soon" title="Появится позже: интеграцию опишет Игорь">
          <button type="button" class="btn" disabled>В реестр</button>
        </span>
        <span class="soon" title="Появится позже: интеграцию опишет Игорь">
          <button type="button" class="btn" disabled>Сократить для пачки</button>
        </span>
        <button type="button" class="btn" @click="copyAll">Скопировать всё</button>
        <button type="button" class="btn" @click="download">Скачать CSV</button>
        <button type="button" class="btn ghost" @click="clearRows">Очистить</button>
        <button type="button" class="btn primary" aria-label="Генерировать ссылки" @click="generate">
          Сгенерировать {{ rows.length }} {{ linksWord(rows.length) }}
        </button>
      </div>
    </section>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useToast } from 'primevue/usetoast'
import {
  addressIssue,
  buildUtmUrl,
  downloadCsv,
  formatTermDate,
  formatUrlForDisplay,
  valueFromEvent,
} from './utm-utils'

const props = defineProps({
  origins: { type: Array, default: () => [] },
  campaigns: { type: Array, default: () => [] },
})

const toast = useToast()
let seq = 1
const lead = ref('')
const campaign = ref('')
const termDate = ref(null)
const rows = ref([blank(), blank(), blank()])

function blank() {
  return { id: seq++, url: '', origin: '', platform: '', eventId: null }
}

function uniq(list, key, pred) {
  const seen = []
  list.forEach((row) => {
    if (pred && !pred(row)) return
    const value = String(row?.[key] ?? '').trim()
    if (value && !seen.includes(value)) seen.push(value)
  })
  return seen
}

const leads = computed(() => uniq(props.origins, 'lead'))

function originsFor(currentLead) {
  return uniq(props.origins, 'origin', (row) => String(row.lead ?? '').trim() === currentLead)
}
function platformsFor(row) {
  return uniq(props.origins, 'platform', (item) =>
    String(item.lead ?? '').trim() === lead.value && String(item.origin ?? '').trim() === row.origin
  )
}
function eventsFor(row) {
  return props.origins.filter((item) =>
    String(item.lead ?? '').trim() === lead.value
    && String(item.origin ?? '').trim() === row.origin
    && String(item.platform ?? '').trim() === row.platform
  )
}
function eventOf(row) {
  return eventsFor(row).find((item) => item.id === row.eventId) || null
}
function issueOf(row) {
  return addressIssue(row.url)
}
function builtOf(row) {
  if (issueOf(row) || !String(row.url || '').trim()) return null
  const ev = eventOf(row)
  return buildUtmUrl({
    path: row.url,
    fields: {
      utm_source: valueFromEvent(ev?.utm_source),
      utm_medium: valueFromEvent(ev?.utm_medium),
      utm_campaign: campaign.value || '',
      utm_content: valueFromEvent(ev?.utm_content),
      utm_term: formatTermDate(termDate.value),
    },
  })
}
function resultOf(row) {
  return builtOf(row)?.url || ''
}
function readyRows() {
  return rows.value
    .map((row) => ({ row, built: builtOf(row) }))
    .filter((item) => item.built?.url)
}

watch(leads, (list) => {
  if (!list.includes(lead.value)) lead.value = list[0] || ''
}, { immediate: true })

watch(lead, () => {
  rows.value.forEach((row) => {
    if (row.origin && !originsFor(lead.value).includes(row.origin)) {
      row.origin = ''
      row.platform = ''
      row.eventId = null
    }
  })
})

function onUrl(row, e) {
  row.url = String(e.target.value || '').replace(/^\s*https?:\/\//i, '')
}
function onOrigin(row, value) {
  row.origin = value || ''
  if (!platformsFor(row).includes(row.platform)) row.platform = ''
  row.eventId = null
}
function onPlatform(row, value) {
  row.platform = value || ''
  row.eventId = null
}
function addRows(count) {
  for (let i = 0; i < count; i += 1) rows.value.push(blank())
}
function removeRow(id) {
  rows.value = rows.value.filter((row) => row.id !== id)
  if (!rows.value.length) rows.value.push(blank())
}
function clearRows() {
  rows.value = [blank()]
}
function linksWord(count) {
  const n10 = count % 10
  const n100 = count % 100
  if (n10 === 1 && n100 !== 11) return 'ссылку'
  if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) return 'ссылки'
  return 'ссылок'
}
function paramOf(built, key) {
  return built?.params?.find((item) => item.key === key)?.value || ''
}
function generate() {
  const ready = readyRows().length
  toast.add({
    severity: ready ? 'success' : 'warn',
    summary: ready ? `Собрано ${ready} ${linksWord(ready)}` : 'Нет ссылок для сборки',
    life: 2500,
  })
}
async function copyAll() {
  const urls = readyRows().map((item) => item.built.url)
  if (!urls.length) {
    toast.add({ severity: 'warn', summary: 'Нет готовых ссылок', life: 2500 })
    return
  }
  try {
    await navigator.clipboard.writeText(urls.join('\n'))
    toast.add({ severity: 'success', summary: `Скопировано ${urls.length}`, life: 2200 })
  } catch {
    toast.add({ severity: 'error', summary: 'Не удалось скопировать', life: 2500 })
  }
}
async function copyOne(url) {
  try {
    await navigator.clipboard.writeText(url)
    toast.add({ severity: 'success', summary: 'Ссылка скопирована', life: 1800 })
  } catch {
    toast.add({ severity: 'error', summary: 'Не удалось скопировать', life: 2500 })
  }
}
function download() {
  const ready = readyRows()
  if (!ready.length) {
    toast.add({ severity: 'warn', summary: 'Нет готовых ссылок', life: 2500 })
    return
  }
  downloadCsv('utm-links.csv', ['url', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'], ready.map((item) => [
    item.built.url,
    paramOf(item.built, 'utm_source'),
    paramOf(item.built, 'utm_medium'),
    paramOf(item.built, 'utm_campaign'),
    paramOf(item.built, 'utm_content'),
    paramOf(item.built, 'utm_term'),
  ]))
}
</script>

<style scoped>
.multi-wrap {
  --border: #e6e8ec;
  --border-strong: #d5d9e0;
  --text: #14181f;
  --muted: #6b7383;
  --muted-2: #98a0ae;
  --accent: #676B52;
  --accent-hover: #565a44;
  --danger: #b4324f;
  --mono: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  --shadow: 0 1px 2px rgba(16, 24, 40, .04), 0 8px 24px -12px rgba(16, 24, 40, .12);
}
.banner {
  display: flex; gap: 10px; align-items: flex-start; background: #fff9ec; border: 1px solid #f1e3c2; color: #7a5c17;
  border-radius: 12px; padding: 12px 14px; font-size: 12.5px; line-height: 1.5; margin-bottom: 18px;
}
.banner b { color: #5f4610; }
.banner .icon { width: 16px; height: 16px; flex: 0 0 auto; margin-top: 1px; color: #b08a2e; }
.card { background: #fff; border: 1px solid var(--border); border-radius: 16px; box-shadow: var(--shadow); }
.multi { padding: 22px 26px 24px; }
.multi-head { margin-bottom: 18px; }
.multi-head h2 { margin: 0 0 4px; font-size: 17px; font-weight: 600; }
.multi-head p { margin: 0; font-size: 12.5px; color: var(--muted); }
.shared { background: #fafbfc; border: 1px solid var(--border); border-radius: 12px; padding: 14px; margin-bottom: 16px; }
.grid3 { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px; }
.lbl { display: block; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: var(--muted-2); margin: 0 0 6px 2px; }
.table-wrap { overflow-x: auto; }
.table { width: 100%; border-collapse: separate; border-spacing: 0; min-width: 920px; }
.table th { text-align: left; font-size: 11px; text-transform: uppercase; letter-spacing: .04em; color: var(--muted-2); font-weight: 600; padding: 0 8px 8px; }
.table td { padding: 6px 8px; vertical-align: middle; border-top: 1px solid #eef0f3; }
.table tr:first-child td { border-top: 0; }
.table .num { width: 28px; color: var(--muted-2); font-size: 11.5px; }
.input {
  height: 38px; border: 1px solid var(--border-strong); border-radius: 10px; background: #fff; padding: 0 12px;
  width: 100%; font-size: 13px; outline: 0; color: var(--text); font-family: var(--mono);
}
.input:focus { border-color: var(--accent); box-shadow: 0 0 0 3px rgba(103, 107, 82, .12); }
.table tr.bad td { background: #fdf3f5; }
.err { font-size: 11px; color: var(--danger); margin-top: 4px; }
.res { font-family: var(--mono); font-size: 11px; color: var(--accent); display: flex; align-items: center; gap: 6px; max-width: 280px; }
.res.empty { color: var(--muted-2); }
.copy { border: 0; background: transparent; color: var(--muted-2); cursor: pointer; }
.row-actions button { border: 0; background: transparent; color: var(--muted-2); border-radius: 7px; padding: 5px; cursor: pointer; }
.row-actions button:hover { background: #f3f4f7; color: var(--danger); }
.multi-foot { display: flex; align-items: center; gap: 10px; margin-top: 16px; flex-wrap: wrap; }
.grow { flex: 1 1 auto; }
.btn {
  display: inline-flex; align-items: center; justify-content: center; gap: 8px; border-radius: 10px;
  border: 1px solid var(--border-strong); background: #fff; padding: 9px 14px; font-size: 13px; font-weight: 500;
  color: var(--text); cursor: pointer; font-family: inherit;
}
.btn:hover { border-color: #b9bfc9; background: #fbfbfc; }
.btn:disabled { opacity: .45; cursor: default; }
.btn.sm { padding: 6px 10px; font-size: 12px; border-radius: 8px; }
.btn.ghost { border-color: transparent; color: var(--muted); }
.btn.primary { background: var(--accent); border-color: var(--accent); color: #fff; }
.btn.primary:hover { background: var(--accent-hover); border-color: var(--accent-hover); }
.soon { display: inline-flex; }
:deep(.utm-select.p-select) { width: 100%; height: 38px; border-radius: 10px; border: 1px solid #d5d9e0; align-items: center; }
:deep(.utm-select .p-select-label) { font-size: 13px; padding-top: 0; padding-bottom: 0; display: flex; align-items: center; }
:deep(.term-picker) { width: 100%; }
:deep(.term-picker .p-inputtext) { height: 38px; border-radius: 10px; border-color: #d5d9e0; width: 100%; }
@media (max-width: 760px) {
  .multi { padding: 16px 14px 18px; }
  .grid3 { grid-template-columns: 1fr; }
  .btn, .input, .row-actions button, .copy { min-height: 44px; }
  .input, :deep(.utm-select .p-select-label), :deep(.term-picker .p-inputtext) { font-size: 16px; }
  :deep(.utm-select.p-select), :deep(.term-picker .p-inputtext) { min-height: 44px; height: 44px; }
}
</style>
